/* istanbul ignore file */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useRef, useContext, useState } from 'react';
import ApplicationContext from '../../../../../context/ApplicationContext';
import { documentsLanguageContent } from '../../../documentsLanguageContent';
import { zipObjectDeep } from 'lodash';

function Signature(props) {
    const { setIsSignatureDrawn, loader } = props;
    const { sessionData, selectedLanguage } = useContext(ApplicationContext);
    const signatureCanvasRef = useRef();
    let isDrawing = false;
    let lastX = 0;
    let lastY = 0;

    document.addEventListener("mouseup", () => {
        isDrawing = false;
    });

    const loadSignatureData = () => {
        const canvas = signatureCanvasRef.current;
        const ctx = canvas.getContext('2d');
        const savedDataUrl = sessionData.patient_details.signature_url || '';
    
        if (savedDataUrl) {
            const img = new Image();
            img.onload = () => {
                ctx.drawImage(img, 0, 0);
            };
            img.src = savedDataUrl;
        }
    };

    useEffect(() => {
        loadSignatureData();
    }, [sessionData]);

    useEffect(() => {
        handleClearSignature();
    }, [signatureCanvasRef])

    const handleClearSignature = () => {
        const canvas = signatureCanvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setIsSignatureDrawn(false);
    };

    const draw = (e) => {
        if(!isDrawing || sessionData.patient_details.signature_url !== '') return;
        const canvas = signatureCanvasRef.current;
        const ctx = canvas.getContext("2d");
        const { offsetX, offsetY } = e;
        ctx.beginPath();
        ctx.strokeStyle = "#000"; // Signature color
        ctx.lineWidth = 2; // Signature line width
        ctx.lineCap = "round";
        ctx.moveTo(lastX, lastY);
        ctx.lineTo(offsetX, offsetY);
        ctx.stroke();
        lastX = offsetX;
        lastY = offsetY;
        setIsSignatureDrawn(true);
    };

    const handleMouseDown = (e) => {
        isDrawing = true;
        const { offsetX, offsetY } = e;
        lastX = offsetX;
        lastY = offsetY;
    };

    const handleMouseUp = () => {
        isDrawing = false;
    };

    useEffect(() => {
        const canvas = signatureCanvasRef.current;
        canvas.addEventListener("mousemove", draw);
        canvas.addEventListener("mousedown", handleMouseDown);
        canvas.addEventListener("mouseup", handleMouseUp);
        canvas.addEventListener("touchmove", handleTouchMove);
        canvas.addEventListener("touchstart", handleTouchStart);
        canvas.addEventListener("touchend", handleTouchEnd);
        return () => {
            canvas.removeEventListener("mousemove", draw);
            canvas.removeEventListener("mousedown", handleMouseDown);
            canvas.removeEventListener("mouseup", handleMouseUp);
            canvas.removeEventListener("touchmove", handleTouchMove);
            canvas.removeEventListener("touchstart", handleTouchStart);
            canvas.removeEventListener("touchend", handleTouchEnd);
        };
    }, []);

    

    // Event handler for drawing
    /* istanbul ignore next */
    function drawMobile(e) {
        if (!isDrawing || sessionData.patient_details.signature_url !== '') return;
        const touch = e.touches[0];
        const canvas = signatureCanvasRef.current;
        const ctx = canvas?.getContext("2d");
        ctx.beginPath();
        ctx.strokeStyle = "#000"; // Signature color
        ctx.lineWidth = 2; // Signature line width
        ctx.lineCap = "round";

        ctx.moveTo(lastX, lastY);
        ctx.lineTo(touch.clientX - canvas.getBoundingClientRect().left, touch.clientY - canvas.getBoundingClientRect().top);
        ctx.stroke();

        [lastX, lastY] = [touch.clientX - canvas.getBoundingClientRect().left, touch.clientY - canvas.getBoundingClientRect().top];
        setIsSignatureDrawn(true);
    }

    const handleTouchMove = (e) => {
        e.preventDefault();
        drawMobile(e);
    };

    const handleTouchStart = (e) => {
        e.preventDefault();
        isDrawing = true;
        const touch = e.touches[0];
        const offsetX = touch.clientX - touch.target.getBoundingClientRect().left;
        const offsetY = touch.clientY - touch.target.getBoundingClientRect().top;
        lastX = offsetX;
        lastY = offsetY;
    };

    const handleTouchEnd = () => {
        isDrawing = false
    };

    return (
        <div className='border-t border-[#70B503] pt-2'>
            <div className='mx-[24px] mb-[30px]'>
                <canvas data-testid="signature_canvas" className="h-[150px] m-auto border-b-2 border-[#D7D7D7]" ref={signatureCanvasRef} id={`signatureCanvas`}></canvas>
            </div>
            <div className="flex justify-end border-t border-[#70B503] pt-[12px] pr-[24px]">
                {sessionData?.patient_details.signature_url === '' && 
                    <button disabled={loader} className="border-2 border-[#797979] text-[#000] text-sm font-normal justify-center items-center px-[8px] py-[2px] rounded bg-[#FFFFFF]" 
                        onClick={() => handleClearSignature()}>{documentsLanguageContent['clear'][selectedLanguage]}</button>}
            </div>
        </div>
    );
}

export default Signature;